import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTheme } from 'styled-components';
import Icons from '../../../../Elements/Icons';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon';
import { TableCellInnerWrapper } from '../TableCell/styled';
import { TableHeadWrapper } from './styled';
export const TableHead = memo(function TableHead({ children, className, dataTestId, $sticky, ...props }) {
    const { order, handleChangeOrder, tooltip } = props;
    const { colors } = useTheme();
    return (_jsx(TableHeadWrapper, { ...props, className: className, sortable: !!handleChangeOrder, onClick: handleChangeOrder, "data-testid": dataTestId, "$sticky": $sticky, children: _jsxs(TableCellInnerWrapper, { ...props, noWrap: true, children: [handleChangeOrder && (_jsx(Icons.Arrow, { size: 16, color: order ? colors.main : colors.black_1, align: order === 'ASC' ? 'top' : 'bottom' })), children, tooltip && _jsx(InfoTooltipIcon, { tooltip: tooltip })] }) }));
});
